import React, { useState, useContext, useEffect } from "react"
import "../css/navbar.css"
import Winners from "../winners"
import Select from "react-select"
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { LanguageContext } from "../LanguageContext"
import { useTranslation } from "react-i18next";
import {service,customStyles,getLanguages} from "../../utils/constant";

const Navbar = () => {
  const { t } = useTranslation("global")
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const { language, changeLanguage } = useContext(LanguageContext)
  const navigate = useNavigate()
  const location = useLocation()
  const isAndroidActive = location.pathname.toLowerCase().includes("/allgames/android")

  const navLinkClass = ({ isActive }) => (isActive ? "active" : undefined)
  const closeMobileMenu = () => setIsNavExpanded(false)


  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const onLogout = () => {
    //localStorage.clear()
    window.location.href = "/unsub"
  }

  const handleChange = (selectedOption) => {
    changeLanguage(selectedOption.value)
  }

  let languages = getLanguages();
  const selectedOption = languages.find((option) => option.value === language)
  const token = localStorage.getItem("token")
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  useEffect(() => {
    setIsNavExpanded(false)
  }, [location.pathname])

  useEffect(() => {
    if (!isNavExpanded) return undefined
    const onKeyDown = (e) => {
      if (e.key === "Escape") setIsNavExpanded(false)
    }
    document.body.style.overflow = "hidden"
    window.addEventListener("keydown", onKeyDown)
    return () => {
      document.body.style.overflow = ""
      window.removeEventListener("keydown", onKeyDown)
    }
  }, [isNavExpanded])

  return (
    <>
      <nav className={`navigation${scrolled ? " scrolled" : ""}`}>
        <div className="nav_inner">
        <a href="/" className="brand-name">
           {service==="mng" ? 
              <img src="/images/logo_mng.png" alt="GS Games Logo" className="img-logo" /> 
           :(service==="mueg"?
              <img src="/images/logo_mueg.png" alt="GS Games Logo" className="img-logo-mueg" />
           :
              <img src="/images/gs_games_logo.png" alt="GS Games Logo" className="img-logo" />
           )
          }
        </a>
        <div className="nav_tools">
          <div className="mobile-icons"> 
             {!!token && (
                <button
                  className="mobile-home-button home_button"
                  onClick={onLogout}
                >
                  <i className="fas fa-house"></i>
                </button>
              )}           
              <button
                className={`mobile-android-button winners_button${isAndroidActive ? " active" : ""}`}
                onClick={() => navigate("/allGames/Android")}
              >
                <i className="fa fa-android"></i>
              </button>

              <button
                className="mobile-winner-button winners_button"
                onClick={openModal}
              >
                <i className="fa-solid fa-trophy"></i>
              </button>
             
          </div>

          {/* )} */}
          <button
            type="button"
            className={`hamburger${isNavExpanded ? " is-open" : ""}`}
            onClick={() => setIsNavExpanded(!isNavExpanded)}
            aria-label={isNavExpanded ? "Close menu" : "Open menu"}
            aria-expanded={isNavExpanded}
          >
            <i className={`fa-solid ${isNavExpanded ? "fa-xmark" : "fa-bars"}`}></i>
          </button>
        </div>

        {isNavExpanded && (
          <button
            type="button"
            className="nav_backdrop"
            aria-label="Close menu"
            onClick={closeMobileMenu}
          />
        )}

        <div
          className={
            isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
          }
        >
          <ul>
            <li>
              <NavLink to="/allGames/Sports" className={navLinkClass} onClick={closeMobileMenu}>
                {t("portalText.sport")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/allGames/Funny" className={navLinkClass} onClick={closeMobileMenu}>
                {t("portalText.funny")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/allGames/Action" className={navLinkClass} onClick={closeMobileMenu}>
                {t("portalText.action")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/allGames/Adventure" className={navLinkClass} onClick={closeMobileMenu}>
                {t("portalText.adventure")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/allGames/Racing" className={navLinkClass} onClick={closeMobileMenu}>
                {t("portalText.racing")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/allGames/Kids" className={navLinkClass} onClick={closeMobileMenu}>
                {t("portalText.kids")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/allGames/Puzzle" className={navLinkClass} onClick={closeMobileMenu}>
                {t("portalText.puzzle")}
              </NavLink>
            </li>
            <li className="mobile-category">
              <NavLink to="/allGames/Android" className={navLinkClass} onClick={closeMobileMenu}>
                {t("portalText.android")}
              </NavLink>
            </li>
            {/* <li>
                <a href="/allGames/Sports">Arcade</a>
            </li> */}

            <>
            {!!token && (
              <li>
                  <button
                    className="logout_button tabletdesktop-logout-button"
                    onClick={onLogout}
                  >
                    <i className="fas fa-house"></i>
                  </button>
              </li>
              )}
              <li>
                {/* <a href="/allGames/Android" className="brand-name"> */}
                <button
                  className={`winners_button tabletdesktop-winner-button${isAndroidActive ? " active" : ""}`}
                  onClick={() => navigate("/allGames/Android")}
                >
                  <i className="fa fa-android"></i> {t("portalText.android")}
                </button>
                {/* </a> */}
              </li>
              <li>
                <button
                  className="winners_button tabletdesktop-winner-button"
                  onClick={openModal}
                >
                  <i className="fa-solid fa-trophy"></i>{" "}
                  {service==="mng"?t("portalText.leaderboard"):t("portalText.winners")}
                </button>
              </li>
              <li className="mobile-lang">
                <Select
                  value={selectedOption}
                  options={languages}
                  onChange={handleChange}
                  styles={customStyles}
                  placeholder="Select Language"
                />
              </li>

             
            </>
          </ul>
        </div>
        </div>
      </nav>
      {/* {!!token && <Winners isOpen={isOpen} closeModal={closeModal} />} */}
      <Winners isOpen={isOpen} closeModal={closeModal} />
    </>
  )
}

export default Navbar
